import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css, useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers.js';
const Svg = styled.svg `
  ${({ direction }) => direction === 'right' &&
    css `
      transform: rotate(-90deg);
    `}
  ${({ direction }) => direction === 'left' &&
    css `
      transform: rotate(90deg);
    `}
  ${({ direction }) => direction === 'top' &&
    css `
      transform: rotate(-180deg);
    `}
`;
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick, direction }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx(Svg, { ref: ref, onClick: onClick, width: size, direction: direction, height: size, viewBox: '0 0 24 24', fill: 'none', className: className, children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6 7L12 13L18 7L20 9L12 17L4 9L6 7Z', fill: fillColor }) }));
});
export default React.memo(Icon);
